import * as React from "react";
import { Link } from "gatsby";
import upperFirst from "lodash/upperFirst";

function Breadcrumbs({ crumbs, pageTitle, ...props }) {
  return (
    <nav className="breadcrumbs" aria-label="breadcrumb" {...props}>
      <ol className="breadcrumb my-0">
        <li className="d-none d-md-inline text-muted me-2">You are here:</li>
        {!crumbs
          ? null
          : crumbs.slice(0, -1).map((crumb) => (
              <li
                className="breadcrumb-item text-truncate"
                key={crumb.pathname}
              >
                <Link to={crumb.pathname}>{upperFirst(crumb.crumbLabel)}</Link>
              </li>
            ))}
        <li
          className="breadcrumb-item active text-truncate"
          key="current"
          aria-current="page"
          
        >
          {pageTitle}
        </li>
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
